<template>
  <div>
    <Verge3DScroll
      :scene="landingPageScene"
      :playAfterMount="playAfterMount"
      ref="verge"
      :zIndex="webglZindex"
      @vergeInitialized="enableScroll"
      @annotationClick="annotationClick"
    />
    <v-row class="mouse-scroll-row" align="end">
      <v-row justify="center">
        <MouseScroll v-if="scrollIcon" />
      </v-row>
    </v-row>
    <div class="scroll-height-container"></div>
    <div class="top-layer-content">
      <v-container>
        <!-- <v-row style="">
          <v-col cols="12">
            <v-btn @click="fullScreen" color="primary">
              Full Screen
            </v-btn>
          </v-col>
        </v-row> -->
      </v-container>
      <ContentOverlay />
    </div>
    <InteractiveDialogue :dialog="dialog" @dialogOff="enableInteraction" />
    <VideoDialog :dialog.sync="videoDialog" @dialogOff="videoDialog = false" />
    <CementDialog
      :dialog.sync="cementDialog"
      @dialogOff="cementDialog = false"
    />
    <SteelDialog :dialog.sync="steelDialog" @dialogOff="steelDialog = false" />
    <SocietyDialog
      :dialog.sync="societyDialog"
      @dialogOff="societyDialog = false"
    />
    <InteractiveControlls
      :enable="interractiveMode"
      @scroll="scrollMode"
      @annotations="toggleAnnotations"
    />
    <InteractiveTour />
  </div>
</template>

<script>
import Verge3DScroll from '@/components/landing/Verge3DScroll.vue'
// import fullscreen from '@/services/fullscreen.js'
import MouseScroll from '@/components/landing/MouseScroll.vue'
import InteractiveControlls from '@/components/landing/InteractiveControlls.vue'
import ContentOverlay from '@/components/landing/ContentOverlay.vue'
import InteractiveDialogue from '@/components/landing/InteractiveDialogue.vue'
import VideoDialog from '@/components/landing/VideoDialog.vue'
import CementDialog from '@/components/landing/CementDialog.vue'
import SocietyDialog from '@/components/landing/SocietyDialog.vue'
import SteelDialog from '@/components/landing/SteelDialog.vue'
import InteractiveTour from '@/components/landing/InteractiveTour.vue'

export default {
  components: {
    Verge3DScroll,
    MouseScroll,
    InteractiveControlls,
    ContentOverlay,
    InteractiveDialogue,
    VideoDialog,
    CementDialog,
    SteelDialog,
    SocietyDialog,
    InteractiveTour
  },
  // ?non reactive data
  y: 0,
  dy: 0,
  contentContainer: null,
  data() {
    return {
      landingPageScene: {
        name: 'landing',
        compressed: false,
        puzzles: false,
        transBackground: false,
        annotations: [
          // todo: add hover text / click text at refactoring
          { text: 'Green Society', anchor: 'an_social' },
          { text: 'Building A Pyramid', anchor: 'an_door' },
          { text: 'Eco Cement', anchor: 'an_pannel' },
          { text: 'The Steel', anchor: 'an_steel' }
        ]
      },
      lerpParam: 0.07,
      // input check for user input for lerpParam
      numberRange: [
        v => v < 1 || 'Value must be smaller than 1',
        v => v > 0 || 'Value Must be bigger than 0'
      ],
      videoSpeed: 0.09,
      // play frames after load
      playAfterMount: {
        frame: 180,
        speed: 5.5
      },
      keyframeMax: 1000,
      dialog: false,
      interractiveMode: false,
      webglZindex: 1,
      annotationState: false,
      scrollIcon: false,
      videoDialog: false,
      cementDialog: false,
      steelDialog: false,
      societyDialog: false,
      tourState: false
    }
  },
  methods: {
    // todo:remove
    rotTween(scrollOffset) {
      const startOffset = Math.PI
      const animeSpeed = 0.6
      const rotScaling = (animeSpeed * Math.PI) / 830
      let zoomFactor = animeSpeed * (1 / 600) * scrollOffset
      let zOffset = animeSpeed * (1 / 20) * scrollOffset
      let viewOffset = animeSpeed * (1 / 38) * scrollOffset
      // prettier-ignore
      let x = (60 * (1-zoomFactor)) * Math.cos(rotScaling * scrollOffset + startOffset)
      // prettier-ignore
      let y = (60 * (1-zoomFactor)) * Math.sin(rotScaling * scrollOffset + startOffset)
      this.$refs.verge.tweenCam(
        [x, y, 35 - zOffset],
        [0, 0, 3.5 + viewOffset],
        0,
        1
      )
    },
    // fullScreen() {
    //   fullscreen('app')
    // },
    enableScroll() {
      this.scrollIcon = true
      window.requestAnimationFrame(this.render)
    },
    lerp(a, b, n) {
      return (1 - n) * a + b * n
    },
    render() {
      // dissalbe scroll icon
      if (this.$options.dy > 0) this.scrollIcon = false
      // lerp
      // console.log('y pos: ' + this.$options.y)
      this.$options.y = this.lerp(
        this.$options.y,
        this.$options.dy,
        this.lerpParam
      )
      // todo: maybe add decimal precission
      this.$options.contentContainer.style.transform = `translateY(-${Math.round(
        this.$options.y
      )}px`
      // this.rotTween(Math.round(this.$options.y))
      let newFrame =
        Math.round(this.videoSpeed * this.$options.y) +
        this.playAfterMount.frame
      // console.log('Frame: ' + newFrame)
      if (newFrame < this.keyframeMax) {
        this.interractiveMode = false
        this.$refs.verge.setFrame(newFrame)
      } else {
        if (this.interractiveMode == false) {
          this.dialog = true
          this.$refs.verge.selectCamera('Othographic')
          this.webglZindex = 3
          return
        }
      }
      window.requestAnimationFrame(this.render)
    },
    // turn on interactive mode
    enableInteraction() {
      this.interractiveMode = true
      this.dialog = false
      this.annotationState = true
      this.$refs.verge.toggleAnotations(this.annotationState)
      this.$tours['landingPageTour'].start()
    },
    scrollMode() {
      this.$refs.verge.selectCamera('Camera')
      this.annotationState = false
      this.$refs.verge.toggleAnotations(this.annotationState)
      window.requestAnimationFrame(this.render)
      window.scrollBy(0, -2800)
      this.webglZindex = 1
    },
    toggleAnnotations() {
      this.annotationState = !this.annotationState
      this.$refs.verge.toggleAnotations(this.annotationState)
    },
    annotationClick(annotation) {
      switch (annotation) {
        case 'an_door':
          this.videoDialog = true
          break
        case 'an_pannel':
          this.cementDialog = true
          break
        case 'an_steel':
          this.steelDialog = true
          break
        case 'an_social':
          this.societyDialog = true
          break
      }
    }
  },
  beforeCreate() {
    // !dissable scroll history, allways start on top of page
    history.scrollRestoration = 'manual'
  },
  mounted() {
    // get DOM objects for content and scroll div
    this.$options.contentContainer = document.querySelector(
      '.top-layer-content'
    )
    let scrollHeightContainer = document.querySelector(
      '.scroll-height-container'
    )
    // let shippingOverlaySection = document.querySelector(
    //   '.overlay-section-container'
    // )
    // set height of scroll div to content height
    scrollHeightContainer.style.height =
      this.$options.contentContainer.offsetHeight + 'px'
    // window.requestAnimationFrame(this.render)
    // ? use scroll
    window.addEventListener('scroll', () => {
      this.$options.dy = window.scrollY
    })
    window.scroll = (0, 0)
    // ? create trigger for section visuality
    // var observer = new IntersectionObserver(
    //   entries => {
    //     this.updateFrames = !entries[0].isIntersecting
    //     if (entries[0].isIntersecting === true)
    //       console.log('Element has just become visible in screen')
    //   },
    //   { root: null, threshold: [0.35] }
    // )

    // observer.observe(document.querySelector('.overlay-section-container'))
  },
  beforeDestroy() {
    // set scroll history back to auto
    history.scrollRestoration = 'auto'
    // scroll back to 0
    window.scrollTo(0, 0)
    // todo: remove all eventlisteners
    // todo: stopp request animation frame
    // todo: stopp intersection observer
    // window.onscroll = null
  }
}
</script>

<style scoped>
.scroll-height-container {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}

.mouse-scroll-row {
  position: absolute;
  top: 0px;
  left: 0px;
  z-index: 3;
  width: 100%;
  height: 100vh;
}
.top-layer-content {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 2;
  width: 100%;
  height: 12300px;
}

.full-width {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 0;
  height: 100vh;
  width: 100%;
}

.container-background {
  background: url('/images/container-with-bg.jpg');
}

.overlay-section-container {
  /* background: url('/images/domes.jpg') rgba(0, 0, 0, 0.9);
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  background-blend-mode: multiply; */
  background: linear-gradient(
    180deg,
    rgba(212, 211, 209, 0) 0%,
    rgba(212, 211, 209, 0.5) 4%,
    rgba(212, 211, 209, 0.6) 6%,
    rgba(212, 211, 209, 0.8) 8%,
    rgba(212, 211, 209, 0.97) 20%,
    rgba(212, 211, 209, 0.99) 80%,
    rgba(212, 211, 209, 0.8) 92%,
    rgba(212, 211, 209, 0.6) 94%,
    rgba(212, 211, 209, 0.5) 96%,
    rgba(212, 211, 209, 0) 100%
  );
}

/* .back-0 {
  background: rgb(42, 39, 39);
}

.back-pic-1 {
  background-image: url('/images/burning-man.jpg');
}

.back-pic-2 {
  background-image: url('/images/burning-man-2.jpg');
} */
</style>
